
ACC.join = {

	bindAll: function ()
	{
		ACC.join.validateEmail();
	},

	validateEmail: function ()
	{
        $("input[name=CSRFToken]").val(ACC.config.CSRFToken)
		$("#img_sign_up").click( function ()
				{
					$.post(ACC.config.requestContextPath + "/join-request/validateEmail",
							  {
							    eMail:$('#in_EmailToSubscribe').val()
							  },
							  function(data,status){
								if(data=="success"){
							    	$('#fm_email_Subscription').attr('action', ACC.config.requestContextPath + "/join-request").submit();
							    }
							    else{
							    	$("#joinEmail").show();
							    	$("#in_EmailToSubscribe").focus();
							    }
							  });
				});
		
	}

};

$(document).ready(function ()
{
	ACC.join.bindAll();
});

